import React from 'react';
import {useTranslation} from 'react-i18next';

interface FilterLayoutProps {
  title: string;
  onClear: () => void;
  onApply: () => void;
  children: React.ReactNode;
}

const FilterLayout: React.FC<FilterLayoutProps> = ({
  title,
  onClear,
  onApply,
  children
}) => {
  const {t} = useTranslation();
  return (
    <>
      <div className="mb-3 px-4 text-sm font-medium text-gray-700">{title}</div>
      <div className="mb-3">
        {children}
      </div>
      <div className="flex px-4 justify-end gap-2">
        <button
          onClick={onClear}
          className="bg-gray-200 hover:bg-gray-300 text-black text-xs px-3 py-1 rounded-sm transition-colors"
        >
          {t('gallery.filters.clear')}
        </button>
        <button
          onClick={onApply}
          className="bg-gray-800 hover:bg-black text-white text-xs px-3 py-1 rounded-sm transition-colors"
        >
          {t('gallery.filters.apply')}
        </button>
      </div>
    </>
  );
};

export default FilterLayout;
